// @flow
import React from 'react'
import i18n from 'i18next'
import Link from '../../../../Link'
import ArrowIcon from '../../../../icons/ArrowIcon'
import {
  PanelWrapper,
  PanelHeader,
  PanelBody,
  PanelItem,
  IconWrapper,
  PanelList
} from '../styles'

const TRANSITION_ACTIVE_DELAY = 100

type Props = {
  catalogID: string,
  category: string,
  activeCategory: string,
  onCategoryClick: Function,
  onProductClick: Function,
  productID: number,
  products: Array<Object>
}

type State = {
  panelBodyHeight: number,
  panelBodyTransition: boolean
}

class CategoryPanel extends React.Component<Props, State> {
  panelListRef = React.createRef()
  transitionTimeout = null

  state = {
    panelBodyHeight: 0,
    panelBodyTransition: false
  }

  componentDidMount () {
    if (this.panelListRef.current) {
      const panelBodyHeight = this.panelListRef.current.clientHeight
      this.setState({ panelBodyHeight })
      this.transitionTimeout = this.addPanelBodyTransition()
    }
  }

  componentWillUnmount () {
    if (this.transitionTimeout) {
      clearTimeout(this.transitionTimeout)
    }
  }

  isCategoryActive () {
    return this.props.category === this.props.activeCategory
  }

  getPanelBodyHeight () {
    return this.isCategoryActive() ? this.state.panelBodyHeight : 0
  }

  addPanelBodyTransition = () =>
    setTimeout(() => {
      this.setState({ panelBodyTransition: true })
    }, TRANSITION_ACTIVE_DELAY)

  render () {
    return (
      <PanelWrapper>
        <PanelHeader
          onClick={() => this.props.onCategoryClick(this.props.category)}
        >
          <IconWrapper isActive={this.isCategoryActive()}>
            <ArrowIcon />
          </IconWrapper>
          <p>{i18n.t(`catalog.type.${this.props.category}`)}</p>
        </PanelHeader>
        <PanelBody
          height={this.getPanelBodyHeight()}
          isTransitionActive={this.state.panelBodyTransition}
        >
          <PanelList ref={this.panelListRef}>
            {this.props.products.map((product, idx) => {
              return (
                !product.hideFromSite && (
                  <PanelItem
                    key={idx}
                    onClick={this.props.onProductClick}
                    active={i18n.t(product.productID) === this.props.productID}
                  >
                    <Link
                      key={idx}
                      to={i18n
                        .t('routes.PRODUCT')
                        .replace(':productID', i18n.t(product.productID))
                        .replace(':slug', i18n.t(product.slug))}
                    >
                      <p>{i18n.t(`${product.title}`)}</p>
                    </Link>
                  </PanelItem>
                )
              )
            })}
            {this.props.products.length > 1 && (
              <PanelItem active={this.props.catalogID === this.props.category}>
                <Link
                  to={i18n
                    .t('routes.CATALOG')
                    .replace(':type', this.props.category)}
                >
                  <p>
                    {i18n.t(`catalog.seeEverything.${this.props.category}`)}
                  </p>
                </Link>
              </PanelItem>
            )}
          </PanelList>
        </PanelBody>
      </PanelWrapper>
    )
  }
}

export default CategoryPanel
